import { Page } from "containers/app/types";
import { SchoolIDState } from "global-states";
import { CSSProperties, useMemo } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { Icon, Menu } from "semantic-ui-react";

const MenuContainerStyle: CSSProperties = {
  display: "flex",
  height: "3.1rem",
  margin: 0,
};

const MenuDividerStyle: CSSProperties = {
  flex: 1,
};

const TopBarMenu = ({
  onSidebarToggle,
  pages,
}: {
  onSidebarToggle: () => void;
  pages: Page[];
}) => {
  const location = useLocation();
  const history = useHistory();
  const schoolID = useRecoilValue(SchoolIDState);

  function onPageNavigate(path: string) {
    history.push(path.replaceAll(":uid", schoolID));
  }

  const displayPages = useMemo(() => {
    if (location.pathname.includes("/integration")) {
      return pages.filter((page) => page.path.includes("/integration"));
    } else {
      return pages.filter((page) => !page.path.includes("/integration"));
    }
  }, [location.pathname, pages]);

  return (
    <Menu pointing secondary style={MenuContainerStyle}>
      <Menu.Item onClick={onSidebarToggle}>
        <Icon name="align justify" style={{ cursor: "pointer" }} />
      </Menu.Item>
      <div style={MenuDividerStyle} />
      {displayPages.map((page) => (
        <Menu.Item
          key={page.path}
          name={page.name}
          active={location.pathname === page.path}
          onClick={() => onPageNavigate(page.path)}
        />
      ))}
      <div style={MenuDividerStyle} />
    </Menu>
  );
};

export default TopBarMenu;
